import AddProjectModal from './AddProjectModal';

export default AddProjectModal;
